import { render, staticRenderFns } from "./NamaBarang.vue?vue&type=template&id=1f5ecb80&"
import script from "./NamaBarang.vue?vue&type=script&lang=js&"
export * from "./NamaBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports